<div class="navbar">
  <!-- Logo -->
  <a class="logo-badge" routerLink="/dashboard" aria-label="Advokit home">
    <img class="logo-badge__mark" src="/assets/advokit-wordmark.svg" alt="" />
  </a>

  <button pButton type="button" icon="pi pi-bars" class="p-button-rounded p-button-text navbar-icon-btn navbar-menu-toggle"
    (click)="toggleSidebar()" aria-label="Menu"></button>

<!-- COMMENTED FOR BETA TESTING -->
  <!-- Search Bar -->
  <!-- <div class="search-container">
    <i class="pi pi-search search-icon"></i>
    <input type="text" class="search-input"
      placeholder="Търсене във всички обекти (клиенти, дела, казуси, задачи, файлове)..." readonly />
  </div> -->

  <!-- Right Side Icons -->
  <div class="navbar-actions">
    <!-- COMMENTED FOR BETA TESTING -->
    <!-- <button pButton type="button" icon="pi pi-bell" class="p-button-rounded p-button-text navbar-icon-btn"
      aria-label="Notifications"></button>
    <button pButton type="button" icon="pi pi-cog" class="p-button-rounded p-button-text navbar-icon-btn"
      aria-label="Settings"></button> -->
    <button pButton type="button" icon="pi pi-user" class="p-button-rounded topbar-avatar"
      (click)="profileMenu.toggle($event)" aria-label="Profile"></button>
  </div>

  <p-menu #profileMenu [popup]="true" [model]="profileItems" [appendTo]="'body'" [class]="'navbar-menu'"></p-menu>

  <!-- Profile Modal -->
  <app-profile-modal [(visible)]="showProfileModal"></app-profile-modal>
</div>